const isFetchingLeadComplete = (state) => state.leadCompletePage.isFetchingLeadComplete;

const getCode = (state) => state.leadCompletePage.code;

export default {
    isFetchingLeadComplete,
    getCode
};
